import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as IgStory } from '../../images/ig-story.svg';

export const IgStoryIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={IgStory} />
);

export default IgStoryIcon;
